import {Controller, useForm} from "react-hook-form";
import {Box, InputAdornment, Stack, TextField, Typography} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import Button from "@mui/material/Button";
import React, {useState} from "react";
import axios, {isAxiosError} from "axios";
import {useNavigate} from "react-router-dom";
import {LoadingButton} from '@mui/lab';
import { useTranslation } from "react-i18next";

const ForgetPasswordForm = () => {
    const { t } = useTranslation();
    const {
        handleSubmit,
        control,
        setError,
        formState: {errors},
    } = useForm({
        mode: "onChange",
    });
    const [isLoading, setIsLoading] = useState(false);
    const nav = useNavigate();
    const onSubmit = (data) => {
        setIsLoading(true);

        axios.post(`/Auth/ForgotPassword`, {documentNumber: data.idNumber}).then(res => {
            const userId = res.userId;
            setIsLoading(false);
            nav(`/code-check/${userId}`);
        }).catch(e => {
            setIsLoading(false);
            setError("idNumber", {message: e.response.data.message})

        });
    }
    return (
        <Stack sx={{p: 3, gap: 10, width: "90%"}}>
            <Typography
                sx={{fontWeight: "bold", alignSelf: "center"}}
                color="primary.main"
                variant="h5"
            >
                {t('forgot_title')}
            </Typography>
            <Stack>
                <Typography sx={{fontWeight: "bold"}}>{t('forgot_idLabel')}</Typography>
                <Controller
                    name="idNumber"
                    control={control}
                    rules={{
                        required: t('login_idRequired'),
                        pattern: {
                            value: /^[a-zA-Z0-9]{6,10}$/,
                            message: t('login_idInvalid'),
                        },
                    }}
                    render={({field}) => (
                        <TextField
                            {...field}
                            variant="standard"
                            inputProps={{
                                style: {
                                    textAlign: "center",
                                    height: 37,
                                    borderBottomRightRadius: 0,
                                    borderTopRightRadius: 0,
                                },
                            }}
                            InputProps={{
                                disableUnderline: true,
                                placeholder: t('login_idPlaceholder'),
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 48,
                                                height: 48,
                                                backgroundColor: "#EAF0F7",
                                                borderBottomRightRadius: 10,
                                                borderTopRightRadius: 10,
                                            }}
                                        >
                                            <PersonIcon color="primary"/>
                                        </Box>
                                    </InputAdornment>
                                ),
                            }}
                            FormHelperTextProps={{
                                sx: {
                                    textAlign: "start",
                                },
                            }}
                            error={!!errors.idNumber}
                            helperText={errors.idNumber ? errors.idNumber.message : ""}
                        />
                    )}
                />
            </Stack>

            <LoadingButton
                type="sumbit"
                loading={isLoading}
                sx={{width: "80%", alignSelf: "center"}}
                variant="contained"
                onClick={handleSubmit(onSubmit)}
            >
                <Typography>{t('forgot_submit')}</Typography>
            </LoadingButton>
        </Stack>
    );
}
export default ForgetPasswordForm;